import * as Sentry from '@sentry/react';

import settings from 'src/settings';

Sentry.init({
  environment: settings.VITE_APP_SENTRY_ENVIRONMENT,
  release: settings.VITE_APP_SENTRY_RELEASE,
  dsn: settings.VITE_APP_SENTRY_DSN,
  integrations: [Sentry.reactRouterV5BrowserTracingIntegration({ history })],
  sendDefaultPii: false, // explicitly exclude header/cookie data

  tracesSampleRate: 0,

  // scrub personal data
  beforeSend(event) {
    const user = event.user;

    if (user?.username) {
      delete user.username;
    }
    if (user?.email) {
      delete user.email;
    }
    if (user?.ip_address) {
      delete user.ip_address;
    }
    return event;
  },
});
